import * as actions from "./actionsTypes";

const initialData = {
  loader: false,
  saveLoader: false,
  goalPerYear: null,
  formError: null,
  goalPerYearFail: null,
};

export default function GoalPerYearReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_GOAL_PER_YEAR:
      return { ...state, loader: action.payload };

    case actions.SAVE_LOADER_GOAL_PER_YEAR:
      return { ...state, saveLoader: action.payload };

    case actions.GET_GOAL_PER_YEAR:
      return { ...state, goalPerYear: action.payload };

    case actions.GOAL_PER_YEAR_FAIL:
      return { ...state, goalPerYearFail: action.payload };

    case actions.FORM_GOAL_PER_YEAR_FAIL:
      return { ...state, formError: action.payload };

    default:
      return state;
  }
}
